export default "__VITE_ASSET__BsjEnSSd__"